@if (order$ | async; as order) {
  <div class="cx-order-items container">
    <h3 class="cx-order-items-header mt-4">
      {{ 'checkoutOrderConfirmation.orderItems' | cxTranslate }}
    </h3>
    <cx-promotions [promotions]="order.appliedOrderPromotions || []"> </cx-promotions>
    <app-custom-cart-item-list-stock
      [items]="order.entries"
      [promotionLocation]="promotionLocation"
      [readonly]="true"
      [showStockStatus]="false"
      >
    </app-custom-cart-item-list-stock>
  </div>
}
